<template>
  <div>
    <nav class="level has-shadow">
      <div class="container">
        <div class="level-left">
          <div class="level-item">
            <router-link :to="$entity.toSearchRoute(type)" class="button" exact>Back to Search</router-link>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item" v-if="metadata">
            <button class="button" :class="{ 'is-link': isMetaDataModalOpen }" @click="isMetaDataModalOpen = true">
              <fa-icon icon="question-circle"></fa-icon>
            </button>
          </div>
          <div class="level-item" v-if="entity">
            <button class="button is-danger" type="button" @click="confirmDelete">Delete</button>
          </div>
        </div>
      </div>
    </nav>

    <modal v-if="isMetaDataModalOpen" @close="isMetaDataModalOpen = false">
      <div class="box">
        <h1 class="title">{{ type | toTitleCase }} MetaData</h1>

        <tree-view :data="metadata"></tree-view>
      </div>
    </modal>
  </div>
</template>

<script>
import Library from '@/library'

export default {
  name: 'ViewComponentNavbar',

  props: {
    type: {
      required: false
    },

    entity: {
      required: false
    }
  },

  data () {
    return {
      isMetaDataModalOpen: false
    }
  },

  methods: {
    confirmDelete () {
      this.$dialog.confirm({
        title: `Deleting ${Library.Filters.toTitleCase(this.type)}`,
        message: `Are you sure you want to <b>delete</b> this ${Library.Filters.toTitleCase(this.type)}?
          This action cannot be undone.`,
        confirmText: `Delete ${Library.Filters.toTitleCase(this.type)}`,
        type: 'is-danger',
        onConfirm: () => this.onDelete()
      })
    },

    async onDelete () {
      const loader = this.$loading.open()

      try {
        await this.$entity.remove(this.type, this.entity.id)

        this.$snackbar.open(`Successfully deleted ${Library.Filters.toTitleCase(this.type)}.`)
        this.$entity.toSearch(this.type)
      } catch (e) {
        console.error(e)
        this.$snackbar.open({
          message: `Failed to delete ${Library.Filters.toTitleCase(this.type)}.`,
          type: 'is-danger',
          actionText: null
        })
      } finally {
        loader.close()
      }
    }
  },

  computed: {
    metadata () {
      return this.$store.getters['metadata/findMetaData'](this.type)
    }
  },

  components: {
    Modal: Library.Components.Modal
  }
}
</script>
